<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Reporting Services</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Reporting Services</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->
<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>What is SSRS?</h3>
                    <p>SSRS stands for SQL Server Reporting Services is a reporting software that allows you to produce
                        formatted reports with
                        tables in the form of data, graph, images, and charts. These reports are hosted on a server that
                        can be executed any
                        time using parameters defined by the users. It is part of Microsoft SQL Server Services suite.
                    </p>
                    <h3>Why SSRS?</h3>
                    <p>
                        Here, are prime reasons for using SSRS tool:

                        SSRS is an enhanced tool compared to Crystal Reports
                        Faster processing of reports on both relational and multidimensional data
                        Allows better and more accurate Decision-making mechanism for the users
                        Allows users to interact with information without involving IT professionals
                        It provides a World Wide Web-based connection for deploying reports. Hence, reports can be
                        accessed over the internet
                        SSRS allows reports to be exported in different formats. You can deliver SSRS reports using
                        emails
                        SSRS provides a host of security features, which helps you to control, who can access which
                        report
                    </p>



                    <div class="text-result">
                        <h3>Example of SSRS reporting</h3>
                        <p>Consider a SSRS report example of a medical research institute where patients are recruited
                            for various clinical trials.

                            The staff in the institute creates a database record for each patient.

                            Once they agree to be part of the trial, and the hospital gets the payment form the drug
                            company based on the price at
                            which it is ready to participate.

                            Without SSRS, the medical institute would need to manually email a report to the pharma
                            company with the total number of
                            weekly participants. The institute must also add details of every patient included in the
                            trial, the number of drugs
                            used, and all the unwanted situations. As a result, the time taken to collect and send this
                            data in the correct format
                            may consume loads of valuable time in the clinic.

                            If the institute were recording data, with the help of SSRS tool, they would be able to
                            produce on-demand reports in a
                            pre-defined format.

                            With SSRS, the drug company can access the report on the cloud, run the report at any time
                            to get the latest data from
                            the clinic.</p>
                    </div>

                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">MSSQL</a></li>
                        <li><a routerLink="/technology-expertise">MySQL</a></li>
                        <li><a routerLink="/technology-expertise">MongoDB</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/db-management-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/db-management-services">Database Management</a></h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>


            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/powerbi-services">
                            <img src="assets/img/services/services-9.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/powerbi-services">PowerBI</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->